import React from 'react'
import cx from 'classnames'
import styles from './H2El.module.css'

const H2El = ({ children, color = 'light', extraClasses = [] }) => {
  return (
    <h2
      style={{
        // padding: '0px 30px',
        color:
          (color === 'dark' && '#212121') || (color === 'light' && '#ffffff')
      }}
      className={cx(styles.titleStyles, ...extraClasses)}
    >
      {children}
    </h2>
  )
}

export default H2El
